export default __webpack_public_path__ + "static/media/violations.f550a260.svg";